import { useState, useEffect } from 'react';
import '../../../../css/custom-scrollbar.css';
import { useMyContext } from '../../../../context/MyContext';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { Button, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PaginationItem from '@mui/material/PaginationItem';
import { MdDashboard } from 'react-icons/md';
import { ndrList, Base_Url, ndr, pendingApi, ndrStatusList, ndrAction } from '../../../../config/config';
import { toast } from 'react-toastify';
import { CgSearch } from "react-icons/cg";
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import Ndrmodel from '../../../../component/b2c/models/ndrModel';
import axios from 'axios';


export default function NDRDashboard() {
  const [activeTab, setActiveTab] = useState('Action Pending');
  const [isPageLoading, setIsPageLoading] = useState(false)
  const { setorderId } = useMyContext()
  const [limit, setLimit] = useState(10);
  const [ndrListData, setNdrListData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [apiTotalItems, setApiTotalItems] = useState(0);
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [ndrdata, setNdrData] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [pagination, setPagination] = useState({
    'Action Pending': 1,
    'Action Taken': 1,
    'RTO Delivered': 1,
    'All Details': 1,
  });

  const navigateForTrack = useNavigate();
  const tabs = ['Action Pending', 'Action Taken', 'RTO Delivered', 'All Details'];
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');

  const handleViewClick = (ndr) => {
    if (ndr.order_partner?.toLowerCase() === "ekart") {
      setNdrData(ndr);
      setIsPopupOpen(true);
    } else {
      handleRemmitance(ndr);
    }
  };

  const handleRemmitance = async (data) => {
    setIsPageLoading(true);
    const editNdrEndpoint = Base_Url + ndrAction;

    const payload = {
      order_id: data.order_id,
      action: "Re-attempt",
    };

    try {
      const response = await axios.post(editNdrEndpoint, payload, {
        headers: {
          token: token,
          cus_id: cusid,
          "Content-Type": "application/json",
        },
      });

      if (response.data.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(response.data.message || "NDR data updated successfully");
        setIsPageLoading(false);
      } else {
        toast.error(response.data.message || "Failed to update NDR data");
        setIsPageLoading(false);
      }
    } catch (error) {
      const errorData = error.response?.data;
      if (errorData?.messages && typeof errorData.messages === "object") {
        const detailedErrors = Object.values(errorData.messages).join(", ");
        toast.error(detailedErrors || "Validation error occurred");
        setIsPageLoading(false);
      } else {
        toast.error(errorData?.message || "An error occurred while updating NDR data");
        setIsPageLoading(false);
      }
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleClose = () => {
    setIsPopupOpen(false);
    setNdrData(ndr);
  };

  useEffect(() => {
    fetchNdrListByCurrentTab();
  }, [activeTab, pagination[activeTab], limit]);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setNdrListData(originalData);
      setTotalOrders(apiTotalItems);
    } else {
      const filtered = originalData.filter(item =>
        item.waybill?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setNdrListData(filtered);
      setTotalOrders(filtered.length);
    }
  }, [searchQuery, originalData, apiTotalItems]);

  const renderTableHeaders = () => {
    const commonHeaders = ['Order ID', 'AWB No.', 'NDR Count', 'Reason', 'Last Updated'];

    if (activeTab === 'Action Pending' || activeTab === 'All Details' || activeTab === 'Action Taken') {
      return [...commonHeaders, 'Action'];
    }
    return commonHeaders;
  };

  const fetchNdrListByCurrentTab = async () => {
    const pageNumber = pagination[activeTab];
    const limitNumber = Number(limit) || 10;
    setIsPageLoading(true);
    try {
      let url = '';
      if (activeTab === 'Action Pending') {
        url = `${Base_Url}${ndrList}/Pending?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'Action Taken') {
        url = `${Base_Url}${ndrStatusList}?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'RTO Delivered') {
        url = `${Base_Url}${ndrList}/RTO?page=${pageNumber}&limit=${limitNumber}`;
      } else if (activeTab === 'All Details') {
        url = `${Base_Url}${ndrList}?page=${pageNumber}&limit=${limitNumber}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (result.status === "SUCCESS") {
        const data = Array.isArray(result.data) ? result.data : [];
        const totalItems = result.pagination?.totalItems || 0;

        setOriginalData(data);
        setNdrListData(data);
        setApiTotalItems(totalItems);
        setTotalOrders(totalItems);
        setIsPageLoading(false);

      } else {
        toast.error(result.message || "Failed to fetch data");
        setNdrListData([]);
        setTotalOrders(0);
        setOriginalData([]);
        setApiTotalItems(0);
        setIsPageLoading(false);
      }
    } catch (error) {
      console.error('API error:', error.message);
      toast.error("An error occurred while fetching data");
      setNdrListData([]);
      setTotalOrders(0);
      setOriginalData([]);
      setApiTotalItems(0);
      setIsPageLoading(false);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPagination(prev => ({
      ...prev,
      [activeTab]: value,
    }));
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPagination(prev => ({
      ...prev,
      [activeTab]: 1,
    }));
  };

  const handleReturn = async (order_id, action) => {
    try {
      const urlPost = Base_Url + ndrAction;
      setIsPageLoading(true);
      const response = await fetch(urlPost, {
        method: 'POST',
        headers: {
          token: token,
          cus_id: cusid || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: order_id,
          action: action
        }),
      });

      const result = await response.json();

      if (result.status === "SUCCESS") {
        fetchNdrListByCurrentTab();
        toast.success(result.message);
        setIsPageLoading(false);
      } else {
        toast.error(result.message || "Action failed");
        setIsPageLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while processing your request");
      console.error('API error:', error.message);
      setIsPageLoading(false);
    }
  };

  const handleClick = (orderID) => {
    setorderId(orderID);
    navigateForTrack("/shipments/tracking ");
  }

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
  };

  const clearSearch = () => {
    setSearchQuery('');
  };

  const TAB_ICONS = {
    'Action Pending': (
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    'Action Taken': (
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    'RTO Delivered': (
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17l-5-5m0 0l5-5m-5 5h12a4 4 0 010 8h-1" />
      </svg>
    ),
    'All Details': (
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  };

  const renderTableRow = (item, index) => {
    const commonCells = [
      <td
        key="orderId"
        onClick={() => handleClick(item.order_id)}
        className={`relative group px-3 py-2 text-[10px] cursor-pointer hover:underline decoration-1 underline-offset-2 font-semibold transition-colors ${isDarkMode ? 'text-blue-400 hover:text-blue-300' : 'text-gray-900'}`}
      >
        {item.order_id || "N/A"}
        <div className={`absolute left-0 top-full mt-1 hidden group-hover:block text-white text-[8px] rounded-md px-2 py-1 shadow-lg z-20 whitespace-nowrap ${isDarkMode ? 'bg-gray-800' : 'bg-black'}`}>
          📦 Track shipment
          <div className={`absolute -top-1 left-3 w-2 h-2 rotate-45 ${isDarkMode ? 'bg-gray-800' : 'bg-black'}`}></div>
        </div>
      </td>,
      <td key="awbNo" className={`px-3 py-2 text-[10px] font-mono font-medium ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
        {item.waybill || "N/A"}
      </td>,
      <td key="count" className={`px-3 py-2 text-[10px] font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        {item.count || "N/A"}
      </td>,
      <td key="reason" className="px-3 py-2">
        <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[9px] font-medium border ${isDarkMode ? 'bg-gray-800 text-gray-300 border-gray-700' : 'bg-gray-100 text-gray-700 border-gray-200'}`}>
          {item.reason || "N/A"}
        </span>
      </td>,
      <td key="lastUpdated" className={`px-3 py-2 text-[9px] font-mono ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        {item.updated_at || "N/A"}
      </td>,
    ];

    if (activeTab === 'Action Pending') {
      commonCells.push(
        <td key="action" className="px-3 py-2">
          <div className="flex items-center gap-1.5">
            <button
              onClick={() => handleViewClick(item)}
              className={`px-2.5 py-1 text-[9px] shadow-lg font-medium rounded-md transition-colors ${isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-[#293681] text-white hover:opacity-80'}`}
            >
              Reattempt
            </button>
            <button
              onClick={() => handleReturn(item.order_id, 'Return')}
              className={`px-2.5 py-1 text-[9px] font-medium rounded-md border transition-colors ${isDarkMode ? 'bg-red-600 text-white border-red-700 hover:bg-red-700' : 'bg-red-600 text-white border-gray-300 hover:bg-gray-100'}`}
            >
              Return
            </button>
          </div>
        </td>
      );
    } else if (activeTab === 'All Details' || activeTab === 'Action Taken') {
      commonCells.push(
        <td key="action" className="px-3 py-2">
          <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[9px] font-medium ${isDarkMode ? 'bg-gray-800 text-gray-200 border border-gray-700' : 'bg-gray-800 text-white'}`}>
            {item.action || "N/A"}
          </span>
        </td>
      );
    }

    return (
      <tr
        key={index}
        className={`transition-colors duration-150 border-b ${isDarkMode ? 'border-gray-800 hover:bg-[#1F2937]/60' : 'border-gray-100 hover:bg-gray-50'}`}
      >
        {commonCells}
      </tr>
    );
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setPagination(prev => ({
      ...prev,
      [tab]: 1,
    }));
    setSearchQuery('');
  };

  const NoDataMessage = () => (
    <tr>
      <td colSpan={renderTableHeaders().length} className="p-10 text-center">
        <div className={`flex flex-col items-center gap-1.5 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
          <CgSearch size={24} />
          <span className="text-[10px] font-medium">No data available</span>
        </div>
      </td>
    </tr>
  );

  const getPaginationCount = () => {
    if (searchQuery.trim() !== '') {
      return 1;
    }
    return Math.ceil(apiTotalItems / limit) || 1;
  };
  const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden transition-colors duration-300 ${isDarkMode ? 'dark bg-[#0B1120]' : 'bg-gray-50'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

            <NavBar />
            <div className="flex flex-1 overflow-hidden">
                           <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>

        <FullPageLoader isLoading={isPageLoading} message="Processing your request..." />

        <div className={`flex-1 flex flex-col overflow-hidden p-3 md:p-4 gap-3 transition-colors duration-300 ${isDarkMode ? 'bg-[#0B1120]' : 'bg-gray-200'}`}>

          {/* Header */}
          <div className="flex-shrink-0 flex items-center justify-between gap-3 flex-wrap">
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors duration-300 ${isDarkMode ? 'bg-[#111827] border border-gray-700' : 'bg-white shadow-xl'}`}>
                <MdDashboard className={`text-base ${isDarkMode ? 'text-pink-400' : 'text-[#601D49]'}`} />
              </div>
              <div>
                <h1 className={`text-sm font-bold tracking-tight transition-colors duration-300 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>NDR Dashboard</h1>
                <p className={`text-[9px] transition-colors duration-300 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>Manage non-delivery reports</p>
              </div>
            </div>

            <div className="relative w-full sm:w-64">
              <div className={`flex items-center border rounded-lg shadow-sm transition-colors duration-300 ${isDarkMode ? 'bg-[#111827] border-gray-700 focus-within:border-gray-500' : 'bg-white border-gray-500 focus-within:border-gray-400'}`}>
                <div className="pl-2.5 pr-1.5">
                  <CgSearch className={`transition-colors duration-300 ${isDarkMode ? 'text-indigo-400' : 'text-blue-600'}`} size={14} />
                </div>
                <input
                  type="text"
                  placeholder="Search by AWB..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className={`flex-1 py-1.5 pr-2 bg-transparent outline-none text-[10px] font-medium transition-colors duration-300 ${isDarkMode ? 'text-gray-200 placeholder-gray-500' : 'text-gray-800 placeholder-gray-400'}`}
                />
                {searchQuery && (
                  <button
                    onClick={clearSearch}
                    className={`mr-1.5 p-0.5 transition-colors rounded-full ${isDarkMode ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className={`flex-shrink-0 p-1 rounded-lg border flex gap-1 overflow-x-auto transition-colors duration-300 ${isDarkMode ? 'bg-[#111827] border-gray-700' : 'bg-white border-gray-200'}`}>
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => handleTabClick(tab)}
                className={`flex items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-md text-[9px] font-medium whitespace-nowrap transition-all duration-200 flex-1 ${
                  activeTab === tab
                    ? (isDarkMode ? 'bg-white text-gray-800 shadow-sm' : 'bg-[#293681] text-white shadow-sm')
                    : (isDarkMode ? 'text-gray-400 border border-transparent hover:bg-gray-800' : 'text-gray-500 bg-white border border-gray-200 hover:bg-gray-100')
                }`}
              >
                {TAB_ICONS[tab]}
                <span>{tab}</span>
              </button>
            ))}
          </div>

          {/* Table */}
          <div className={`flex-1 flex flex-col overflow-hidden rounded-lg border shadow-sm transition-colors duration-300 ${isDarkMode ? 'bg-[#111827] border-gray-800' : 'bg-white border-gray-200'}`}>
            <div className="flex-1 overflow-y-auto overflow-x-auto custom-scrollbar">
              <table className="min-w-full table-auto">
                <thead className={`sticky top-0 z-10 text-[9px] transition-colors duration-300 ${isDarkMode ? 'bg-[#1F2937] text-gray-300' : 'bg-[#DE3E3E] text-white'}`}>
                  <tr>
                    {renderTableHeaders().map((header, index) => (
                      <th key={index} className="px-3 py-2 text-left font-semibold uppercase tracking-wider">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className={`divide-y transition-colors duration-300 ${isDarkMode ? 'divide-gray-800' : 'divide-gray-100'}`}>
                  {ndrListData.length > 0 ? (
                    ndrListData.map((item, index) => renderTableRow(item, index))
                  ) : (
                    <NoDataMessage />
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className={`flex-shrink-0 border-t px-3 py-2 flex flex-col sm:flex-row justify-between items-center gap-1.5 transition-colors duration-300 ${isDarkMode ? 'border-gray-800 bg-[#111827]' : 'border-gray-200 bg-white'}`}>
              <span className={`text-[9px] font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                {searchQuery ? `Filtered: ${totalOrders} / Total: ${apiTotalItems}` : `Total: ${totalOrders}`}
              </span>

              <div className="flex items-center gap-2">
                <select
                  id="limit"
                  value={limit}
                  onChange={handleLimitChange}
                  className={`border rounded-md p-0.5 text-[9px] focus:outline-none focus:ring-1 transition-colors duration-300 ${isDarkMode ? 'bg-[#1F2937] border-gray-700 text-gray-300 focus:ring-gray-500' : 'bg-white border-gray-200 text-gray-700 focus:ring-gray-400'}`}
                  disabled={searchQuery.trim() !== ''}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={totalOrders}>All</option>
                </select>
                <Pagination
                  count={getPaginationCount()}
                  page={searchQuery.trim() !== '' ? 1 : pagination[activeTab]}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  size="small"
                  disabled={searchQuery.trim() !== ''}
                  sx={{
                    '& .MuiPaginationItem-root': {
                      fontSize: '9px',
                      borderColor: isDarkMode ? '#374151' : '#d1d5db',
                      color: isDarkMode ? '#E5E7EB' : '#000',
                      '&.Mui-selected': {
                        backgroundColor: isDarkMode ? '#374151' : '#021A54',
                        color: isDarkMode ? '#fff' : '#fff',
                        borderColor: isDarkMode ? '#4B5563' : '#021A54',
                      },
                      '&:hover': {
                        backgroundColor: isDarkMode ? '#4B5563' : '#F3F4F6',
                      }
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Ndrmodel isopen={isPopupOpen} onClose={handleClose} ndrdata={ndrdata} />
    </div>
  );
}